module.exports = __webpack_public_path__ + "static/img/bg18.d9b10728.png";